import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import s from './DealsModal.scss'
import { DealModalContent } from './DealModalContent'
import swal from 'sweetalert'

const DealsModal = props => {
  const { showAddDealModal, toggleAddDealModal, createDeal, users } = props

  const handleCancel = async () => {
    const confirm = await swal({
      title: 'Are you sure you want to close? All changes will be lost.',
      buttons: ['No', 'Yes'],
      icon: 'warning'
    })
    if (confirm) {
      toggleAddDealModal()
    }
  }

  return (
    <Modal
      keyboard={false}
      backdrop="static"
      isOpen={showAddDealModal}
      toggle={toggleAddDealModal}
      size="xl"
      className={s.modal}
    >
      <ModalHeader toggle={handleCancel} className={s.modalHeader}>
        Add New Opportunity
      </ModalHeader>
      <ModalBody className={s.modalBody}>
        <DealModalContent
          users={users}
          createDeal={createDeal}
          toggleAddDealModal={toggleAddDealModal}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default DealsModal
